import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const Title = styled.h2`
  font-size: ${props => props.theme.fontSizes.xxxlarge};
  position: relative;
  padding-bottom: 15px;
  margin-bottom: 15px;
  
  &::after {
    content: '';
    position: absolute;
    display: block;
    width: 50px;
    height: 3px;
    background: ${props => props.theme.colors.primaryColor};
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }
`;

const Subtitle = styled.p`
  font-size: ${props => props.theme.fontSizes.medium};
  color: ${props => props.theme.colors.grey[600]};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.regular};
  }
`;

const SectionHeader = ({ title, subtitle }) => {
  return (
    <HeaderContainer>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </HeaderContainer>
  );
};

export default SectionHeader;
